import { isAxiosError } from "axios";
export function automationError(error: unknown): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as
      | { detail?: unknown; meta?: { userMsg?: string } }
      | undefined;
    if (typeof data?.detail === "string") return data.detail;
    if (data?.meta?.userMsg) return data.meta.userMsg;
    if (error.response?.status === 409)
      return "This item changed or is still in use. Refresh and review it before trying again.";
    if (error.response?.status === 403)
      return "You don’t have permission to perform this action.";
    if (error.response?.status === 422)
      return "Please check the fields and try again.";
  }
  return "We couldn’t complete this request. Please try again.";
}
